import {useAsync} from 'react-use';
import {pdf} from "presentation/common";

export const useGeneratedThumbnail = (element) => {
    const state = useAsync(async () => {
        try {
            const width = 220;
            const pdfDocument = await pdf.getDocument({
                url: element.url,
                cMapUrl: '../node_modules/pdfjs-dist/cmaps/',
                cMapPacked: true,
            }).promise;

            const firstPage = await pdfDocument.getPage(1);
            const viewport = firstPage.getViewport({scale: width / firstPage.getViewport({scale: 1.0}).width});

            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            canvas.height = 220;
            canvas.width = width;
            canvas.style.width = `${width}px`;
            canvas.style.height = '200px';

            await firstPage.render({
                canvasContext: ctx || {},
                viewport: viewport,
            }).promise;

            if (ctx) {
                //set to draw behind current content
                ctx.globalCompositeOperation = 'destination-over';
                //set background color
                ctx.fillStyle = '#fff';
                //draw on entire canvas
                ctx.fillRect(0, 0, width, 220);
                // create an img from the canvas which contains the page contents
            }

            return canvas.toDataURL();
        }
        catch (e) {
            throw 'Error tratando de obtener el documento.';
        }
    }, [element.url]);

    return {...state};
};
